(function () {
    'use strict';


    GenericReportController.$inject = ['$scope', 'ExportService', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CustomerCustom', 'Customer'];

    function GenericReportController($scope, ExportService, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, ReportService, OrderBagServiceItemCustom, translate, CustomerCustom, Customer) {
        var $ctrl = this;
        $ctrl.fromDateFilter = new Date();
        $ctrl.toDateFilter = new Date();
        $ctrl.selectedCustomer = null;
        $ctrl.isLoading = false;

        $ctrl.cancel = cancel;
        $ctrl.confirm = confirm;
        $ctrl.errorOnCreatingReport = false;
        $ctrl.reportCreatedAndDownload = false;
        $ctrl.errorOnCreatingReport = false;

        /*
        config object must be like this :
            config={
            spname:'nameOfStoredProcedure',
            parameters:[{name:'pname1',value:'value1'},
                        {name:'pname2',value:'value2'}]
                   }
        */
        $ctrl.config = null;


        loadAll()

        function loadAll() {

        }

        function confirm() {

            if ($ctrl.doBeforeExport)
                $ctrl.config = $ctrl.doBeforeExport()

            $ctrl.errorOnCreatingReport = true;
            $ctrl.reportCreatedAndDownload = false;
            $ctrl.errorOnCreatingReport = false;


            if ($ctrl.config) {
                $ctrl.isLoading = true;
                var config = {params: $ctrl.config.parameters};
                JSON.stringify(config)

                ExportService.export_excel_from_storedProcedure($ctrl.config.spname).save(JSON.stringify(config), function (f) {

                    $ctrl.isLoading = false;

                    ExportService.download_excel_file_by_name(f, onExportSuccess);

                }, onExportErrorr);

            } else {
                console.log('generic report config parameter has not set yet!')
            }

        }

        function onExportErrorr(error) {
            $ctrl.errorOnCreatingReport = false;
            $ctrl.reportCreatedAndDownload = false;
            $ctrl.errorOnCreatingReport = true;
            $ctrl.isLoading = false;
        }

        function onExportSuccess(result) {

            $ctrl.errorOnCreatingReport = false;
            $ctrl.reportCreatedAndDownload = true;
            $ctrl.errorOnCreatingReport = false;
            $ctrl.downloadlink = result;
            $ctrl.isLoading = false;
        }

        function cancel() {

        }
    }

    var GenericReport = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/reports/generic_report/generic_report.html',
        controller: GenericReportController,
        bindings: {

            //'spname':'<',
            //'parameters':'<',
            'config': '<',
            'doBeforeExport': '='
        }

    };

    angular
        .module('tikonApp')
        .component('eoGenericReport', GenericReport)


})();
